import { useEffect } from 'react';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useLoginUsers, useSelectedUser } from '../hooks/federatedAuthHooks';
import { CenterContainerFederated } from './CenterContainerFederated';
import { UserAccountList } from './UserAccountList';
import { UserNotFound } from './UserNotFound';

export const SwitchUserFederated = () => {
  const { data: users, isLoading } = useLoginUsers();
  const { selectUser } = useSelectedUser();

  useEffect(() => {
    if (users && users.length === 1) {
      selectUser(users[0].id);
    }
  }, [users, selectUser]);

  if (isLoading || (users && users.length === 1)) {
    return (
      <FullscreenCenter>
        <CircularProgress />
      </FullscreenCenter>
    );
  }

  return (
    <CenterContainerFederated>
      {!users || users.length === 0 ? (
        <UserNotFound />
      ) : (
        <UserAccountList users={users} onSelect={selectUser} />
      )}
    </CenterContainerFederated>
  );
};

const FullscreenCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: ${p => p.theme.palette.bg.secondary};
`;
